import { combineReducers } from 'redux';
import { reducer as reduxFormReducer } from 'redux-form';
import app from './app-reducer';
import flag from './flag-reducer';
import pdf from './pdf-reducer';
import player from './player-reducer';
import user from './user-reducer';

export default combineReducers({
  user,
  app,
  player,
  pdf,
  form: reduxFormReducer,
  flag
});
